import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Dashboard Encuesta',
            sectionTitle: 'Estadísticas Generales',
            mainUsers: 'Total de usuarios',
            mainReservations: 'Total apartados de sala',
            mainParking: 'Capacidad estacionamiento',
            mainAD: 'Conexión LDAP AD TS-MEX',
            surveyTittle: 'Encuestas',
            modueSecondTittle: 'Detalle de respuestas'
        },
        en: {
            moduleTitle: 'Dashboard TSMX Digital',
            sectionTitle: 'Main Statistics',
            mainUsers: 'Total users',
            mainReservations: 'Total room reservations',
            mainParking: 'Parking capacity',
            mainAD: 'LDAP AD TS-MEX connection',
            surveyTittle: 'Surveys',
            modueSecondTittle: 'Answers detail'
        }
    }
}

export default _.merge(messages, defaultMessages)